import { AskDataIndexing } from '~src/datasource/models/IDataSourceInfo';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ISetDatasourceAskDataSettingsParams {
  id: number;
  indexing: AskDataIndexing;
}

export class SetDatasourceAskDataSettingsRequest extends Request<ISetDatasourceAskDataSettingsParams, IEmptyResult> {
  constructor(params: ISetDatasourceAskDataSettingsParams) {
    super('setDatasourceAskDataSettings', params);
  }
}
